module.exports = __webpack_public_path__ + "static/Retail-hero-7725028566a6e8e012778c9824d665d1.png";